import { useAuth } from "@/hooks/useAuth";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

type AppRole = "admin" | "staff" | "client";

const ProtectedRoute = ({
  children,
  requiredRole,
}: {
  children: React.ReactNode;
  requiredRole?: AppRole;
}) => {
  const { user, roles, profile, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) return <Navigate to="/auth" replace />;

  // Admin always has access (no pending check)
  const isAdmin = roles.includes("admin");

  // If user is pending and not admin, send to approval page
  if (!isAdmin && profile?.status !== "active") {
    return <Navigate to="/aguardando-aprovacao" replace />;
  }

  if (requiredRole && !roles.includes(requiredRole)) {
    if (isAdmin) return <Navigate to="/admin" replace />;
    if (roles.includes("staff")) return <Navigate to="/tecnico" replace />;
    if (roles.includes("client")) return <Navigate to="/sindico" replace />;
    return <Navigate to="/auth" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
